import React, { useEffect } from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import logoImage from "../../assets/images/logo.png";
import ReferralBanner from "./components/ReferralBanner";
import { limpiarBaul } from "../../services/referralBaul";

// ─── Estilos compartidos ─────────────────────────────────────────────────────

const cardSx = {
  width: "100%",
  p: { xs: "20px", md: "28px" },
  borderRadius: { xs: "16px", md: "20px" },
  background: "#ffffff",
  boxShadow: "0 2px 4px rgba(0,0,0,0.03), 0 8px 16px rgba(0,0,0,0.03), 0 12px 24px rgba(0,0,0,0.05)",
  border: "1px solid #eaeaea",
  boxSizing: "border-box",
};

const btnSx = {
  mt: 2,
  height: { xs: "46px", md: "48px" },
  borderRadius: "10px",
  bgcolor: "#1877f2",
  fontFamily: "Quicksand-Bold",
  fontSize: { xs: "15px", md: "16px" },
  textTransform: "none",
  boxShadow: "0 4px 12px rgba(24, 119, 242, 0.28)",
  transition: "all 0.2s ease",
  "&:hover": { bgcolor: "#166fe5", boxShadow: "0 6px 16px rgba(24, 119, 242, 0.38)" },
};


// ─── Paso 6: Éxito ────────────────────────────────────────────────────────────

const Success = () => {
  useEffect(() => {
    // Borrar el baúl al finalizar el registro, una vez que ya se renderizó
    // el banner de éxito con los datos del referido.
    limpiarBaul();
  }, []);

  const handleLogin = () => {
    window.location.href = "https://pro.Clinifica.com";
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#ffffff",
      py: { xs: 3, md: 4 },
    }}>
      <Container maxWidth="xs" sx={{ px: { xs: 2, md: 2 } }}>
        <Box sx={cardSx}>
          <Box sx={{ mb: { xs: 2, md: 2.5 }, display: "flex", justifyContent: "center" }}>
            <img src={logoImage} alt="Clinifica" style={{ height: "34px" }} />
          </Box>

          {/* Ícono de éxito */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: "16px", md: "20px" } }}>
            <Box sx={{
              width: { xs: 56, md: 64 },
              height: { xs: 56, md: 64 },
              borderRadius: "50%",
              bgcolor: "#f0fdf4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: { xs: "28px", md: "32px" },
            }}>
              🎉
            </Box>
          </Box>

          <Typography sx={{ fontFamily: "Poppins-SemiBold", fontSize: { xs: "18px", md: "20px" }, color: "#1c1c1c", mb: "6px", textAlign: "center" }}>
            Todo listo 🎊
          </Typography>
          <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { xs: "13px", md: "14px" }, color: "#6b7280", mb: { xs: "24px", md: "28px" }, lineHeight: 1.6, textAlign: "center" }}>
            ¡Te damos la bienvenida! Muy pronto te contactaremos por WhatsApp para brindarte una breve inducción y resolver todas tus dudas.
          </Typography>

          <Button fullWidth variant="contained" onClick={handleLogin} sx={btnSx}>
            Iniciar sesión
          </Button>
        </Box>

        <Box sx={{ mt: "12px" }}>
          <ReferralBanner success={true} />
        </Box>
      </Container>
    </Box>
  );
};

export default Success;
